import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useClearSuggestions } from '../..';
import { LANGUAGES } from '../../../../constants/languages';
import {
  actions as suggestionsActions,
  selectors as suggestionsSelectors,
} from '../../../../store/suggestions';

const useFetchAllSuggestions = (language = LANGUAGES.EN) => {
  const suggestions = useSelector((state) =>
    suggestionsSelectors.selectAllSuggestions(state, { language }),
  );

  const suggestionsAsOptions = useSelector(
    suggestionsSelectors.selectAllSuggestionsAsOptions(language),
  );

  const fetchAllSuggestionsIsFetching = useSelector(
    suggestionsSelectors.selectFetchAllSuggestionsIsFetching,
  );

  const fetchAllSuggestionsSuccess = useSelector(
    suggestionsSelectors.selectFetchAllSuggestionsSuccess,
  );

  const fetchAllSuggestionsError = useSelector(
    suggestionsSelectors.selectFetchAllSuggestionsError,
  );

  const dispatch = useDispatch();

  const fetchAllSuggestions = useCallback(
    (language) => {
      dispatch(suggestionsActions.fetchAllSuggestionsRequest(language));
    },
    [dispatch],
  );

  const clearSuggestions = useClearSuggestions();

  useEffect(() => {
    fetchAllSuggestions(language);
  }, [fetchAllSuggestions, clearSuggestions, language]);

  return {
    suggestions,
    suggestionsAsOptions,
    fetchAllSuggestions,
    fetchAllSuggestionsIsFetching,
    fetchAllSuggestionsSuccess,
    fetchAllSuggestionsError,
    clearSuggestions,
  };
};

export default useFetchAllSuggestions;
